export const calculateItemVAT = (price, quantity, vatRate) => {
	const parsedPrice = parseFloat(price);
	const parsedQuantity = parseInt(quantity, 10);
	const vatRateString = String(vatRate);
	const parsedVatRate = parseFloat(vatRateString.replace(',', '.'));

	if (isNaN(parsedPrice) || isNaN(parsedQuantity) || isNaN(parsedVatRate)) {
		console.warn('NaN encountered in calculateItemVAT', { price, quantity, vatRate });
		return 0;
	}

	return parseFloat((parsedPrice * parsedQuantity * parsedVatRate) / (100 + parsedVatRate)).toFixed(2); // Extract VAT from price including VAT
};

export const calculateTotalVAT = (order) => {
	let totalVAT = 0;

	// Calculate VAT for selected menus
	order.selected_menus?.forEach((menu) => {
		const price = parseFloat(menu.price);
		const quantity = menu.quantity;
		const vatRate = parseFloat(menu.vat_id?.rate);

		totalVAT += parseFloat(calculateItemVAT(price, quantity, vatRate));
	});

	// Calculate VAT for each product in each category
	order.categories?.forEach((category) => {
		// Extra products in the category
		category.extra_products.forEach((product) => {
			const price = parseFloat(product.price);
			const quantity = product.quantity;
			const vatRateString = String(product.vat_id?.rate);
			const vatRate = parseFloat(vatRateString.replace(',', '.'));
			totalVAT += parseFloat(calculateItemVAT(price, quantity, vatRate));
		});
	});

	return parseFloat(totalVAT).toFixed(2); // Return total VAT rounded to 2 decimal places
};
